<template>
    <div class="side-class ex-container">
        <div class="side-class-title">
            <div class="side-class-btn">CFB专家智库</div>
            <div class="more" @click="toMoreExpert">线上咨询</div>
        </div>
        <div
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
        >
            <div class="side-single-hot" v-for="(hot,index) in expertForum" :key="index">
                <div class="hot-content-right" v-if="index < 5">
                    <div class="right-content-bot">
                        <div class="avatar-icon">
                            <img :src="hot.avatar" alt @click="toExpertDetail(hot)" />
                            <svg class="icon" aria-hidden="true">
                                <use xlink:href="#iconzhuanjia" />
                            </svg>
                        </div>
                        <div class="text">
                            <div class="name">
                                <div class="nick">{{hot.nickname}}</div>
                                <i class="el-icon-plus" @click="setFollow(hot)"></i>
                            </div>
                            <div class="spec" @click="toExpertDetail(hot)">{{hot.describe}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                expertForum: [],
                loading: true
            };
        },
        created() {
            this.getExpertForum();
        },
        methods: {
            toExpertDetail(item) {
                this.$router.push({
                    name: 'expertcenter',
                    query: {
                        professor: item.uid
                    }
                });
            },
            toMoreExpert() {
                // 面包屑
                let breadObj = {
                    path: 'expert-base',
                    name: '专家智库'
                };
                this.$store.commit('setBreadArr', breadObj);
                this.$router.push({
                    name: 'expert-base'
                });
            },
            getExpertForum() {
                this.httpGet(this.$root.getExpertList, {})
                    .then(result => {
                        this.expertForum.push(...result.list);
                        this.loading = false;
                    })
                    .catch(err => {
                        this.loading = false;
                        console.error('getExpertList-err', err);
                    });
            },
            setFollow(expert) {
                if (!this.$store.state.login.userInfo.uid) {
                    this.$message({
                        type: 'error',
                        message: '您还没有登录，请先登录！'
                    });
                    return;
                }
                let status = expert.isfollow == 1 ? 2 : 1; // 1关注2 取关
                this.httpPost(this.$root.setUserFollow, {
                    followid: expert.uid,
                    status: status
                })
                    .then(result => {
                        if (status == 1) {
                            this.$message({
                                type: 'success',
                                message: '关注成功！'
                            });
                        } else {
                            this.$message({
                                type: 'success',
                                message: '取关成功！'
                            });
                        }
                        this.loading = true;
                        this.expertForum = [];
                        this.getExpertForum();
                    })
                    .catch(err => {
                        console.error('setFollow-err', err);
                    });
            }
        }
    };
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';

    .ex-container {
        height: 408px;
        margin-top: 20px;
        padding: 0 15px;
    }

    .side-single-hot {
        flex-x(flex-start);

        // padding: 0 16px 5px;
        .hot-index {
            width: 14px;
            height: 14px;
            background: gray9;
            font-size: 12px;
            color: white;
            line-height: 16px;
            flex-center();
        }

        .hot-hot {
            background: red;
        }

        .hot-content {
            margin-left: 5px;
            font-size: 14px;
            color: gray6;
            line-height: 22px;
            ellipsis();
        }
    }

    .side-single-hot:hover {
        cursor: pointer;
    }

    .hot-content-right {
        width: 250px;
        background: white;
        // padding: 0 15px;
    }

    .right-content-bot {
        flex-x(flex-start);
        color: gray9;
        height: 52px;
        font-size: 12px;
        color: rgba(153, 153, 153, 1);
        line-height: 21px;
        margin-top: 15px;

        .avatar-icon {
            position: relative;

            .icon {
                width: 20px;
                height: 20px;
                fill: #f0c328;
                position: absolute;
                right: 5px;
                top: -10px;
                transform: rotate(20deg);
                -ms-transform: rotate(20deg); /* IE 9 */
                -moz-transform: rotate(20deg); /* Firefox */
                -webkit-transform: rotate(20deg); /* Safari 和 Chrome */
                -o-transform: rotate(20deg); /* Opera */
            }
        }

        img {
            width: 52px;
            height: 52px;
            border-radius: 30px;
            margin-right: 5px;
        }

        .text {
            width: 192px;
            font-size: 12px;
            line-height: 21px;
            max-height: 63px;
            height: 100%;
            flex-y(space-between);

            .name {
                width: 100%;
                flex-x(space-between);
                color: #000;

                .nick {
                    width: 100%;
                    font-weight: bold;
                    ellipsis();
                }

                i {
                    border: 1px solid rgba(0, 0, 0, 0.12);
                    // border-radius: 2px;
                    font-size: 9px;
                    padding: 3px;
                    color: rgba(0, 0, 0, 0.15);
                }
            }

            .spec {
                width: 100%;
                color: #666;
                ellipsis();
            }
        }
    }

    .right-cell-container {
        padding: 0px 16px;
        height: 24px;
        margin-top: 0px;
    }

    .right-content-cell {
        height: 24px;
        font-size: 12px;
        color: gray9;
        line-height: 24px;
        ellipsis();
    }

    .right-content-cell:hover {
        cursor: pointer;
    }

    .more {
        more();
    }

    .more:hover {
        cursor: pointer;
        color: blue;
    }
</style>
